import { comparer } from 'mobx';
import { useContext, useEffect, useState } from 'react';
import * as React from 'react';

import { SearchCriteriaContext } from 'stores/contexts';
import { SearchCriteriaModel } from 'stores/models/search-criteria-model';

import { Targeting, TargetingEvent } from './types';

const STARTING_CRITERIA = new SearchCriteriaModel().toJSON();

export const MesoTargeting: React.FunctionComponent = () => {
  const searchCriteria: SearchCriteriaModel = useContext(SearchCriteriaContext);

  if (!(window && searchCriteria)) {
    return null;
  }

  window.meso = window.meso || {};
  window.meso.targeting = window.meso.targeting || [];

  const [prevCriteria, setPrevCriteria] = useState(STARTING_CRITERIA);

  const getAdinfoData = () => {
    const criteriaJSON = searchCriteria.toJSON();

    if (
      prevCriteria.endDate !== criteriaJSON.endDate ||
      prevCriteria.regionId !== criteriaJSON.regionId ||
      prevCriteria.startDate !== criteriaJSON.startDate ||
      !comparer.structural(prevCriteria.rooms, criteriaJSON.rooms) // adults/chidren count
    ) {
      const { regionId, startDate, endDate, adults, children } = searchCriteria;

      return {
        adinfo: {
          dest: regionId,
          ets: startDate,
          ete: endDate,
          numadults: adults,
          numchildren: children
        }
      };
    }

    return {};
  };

  const createTargetingEvent = (regionId: string, defaultTargeting: Targeting) => {
    let updatedTargeting: TargetingEvent = { targeting: defaultTargeting };

    if (regionId) {
      updatedTargeting = { ...updatedTargeting, ...getAdinfoData() };
    }

    return updatedTargeting;
  };

  useEffect(() => {
    const criteriaJSON = searchCriteria.toJSON();

    if (
      prevCriteria.endDate === criteriaJSON.endDate &&
      prevCriteria.regionId === criteriaJSON.regionId &&
      prevCriteria.startDate === criteriaJSON.startDate &&
      comparer.structural(prevCriteria.rooms, criteriaJSON.rooms) && // adults/chidren count
      comparer.structural(prevCriteria.star, criteriaJSON.star) &&
      comparer.structural(prevCriteria.amenities, criteriaJSON.amenities) &&
      comparer.structural(prevCriteria.lodging, criteriaJSON.lodging)
    ) {
      return;
    } else {
      const { regionId, startDate, endDate, adults, children, star, amenities, lodging } = searchCriteria;

      const targetingEvent = createTargetingEvent(regionId, {
        ete: endDate,
        ets: startDate,
        ha: amenities !== undefined ? amenities.toString() : '',
        hpt: lodging !== undefined ? lodging.toString() : '',
        numadults: adults,
        numchildren: children,
        sr: (star && star.toString()) || ''
      });

      window.meso.targeting.push(targetingEvent);

      setPrevCriteria(criteriaJSON);
    }
  });

  return null;
};
